import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ZapIcon } from 'lucide-react';
import { CTA_TEXT, CTA_SUBTEXT } from './data';
export const CHECKOUT_URL = 'https://rutinasimple.com//cart/52743997751577:1';
interface CtaButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  href?: string;
}
export function CtaButton({
  text = CTA_TEXT,
  subtext = CTA_SUBTEXT,
  className = '',
  href = '#oferta'
}: CtaButtonProps) {
  return <div className={`flex flex-col items-center ${className}`} data-id="element-36">
      <motion.a href={href} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.98
    }} className="shimmer-overlay group relative inline-flex w-full max-w-2xl items-center justify-center gap-3 overflow-hidden rounded-2xl bg-accent px-6 py-5 text-center text-base font-extrabold uppercase tracking-wide text-ink-950 shadow-glow-cyan-lg animate-pulse-glow sm:px-10 sm:py-6 sm:text-lg" data-id="element-37">
        <ZapIcon className="hidden h-6 w-6 shrink-0 sm:block" aria-hidden="true" data-id="element-38" />
        <span className="relative z-10 leading-tight" data-id="element-39">{text}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-40" />
      </motion.a>
      {subtext && <p className="mt-3 text-sm text-silver/70" data-id="element-41">{subtext}</p>}
    </div>;
}